/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
  GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  GetApiV1ClassroomdisciplineSharedCourses401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedCourses.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedCourses } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedCourses.ts";

export const getApiV1ClassroomdisciplineSharedCoursesQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/courses" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedCoursesQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedCoursesQueryKey
>;

export function getApiV1ClassroomdisciplineSharedCoursesQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineSharedCoursesQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCourses401>,
    GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedCourses(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de cursos ativos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/courses}
 */
export function useGetApiV1ClassroomdisciplineSharedCourses<
  TData = GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ClassroomdisciplineSharedCoursesQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedCoursesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedCoursesQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCourses401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedCoursesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedCoursesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedCourses401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
